import type { DuplicateRequestResponse } from "@nlc/shared-types";
import type { DefaultValues, UseFormReset } from "react-hook-form";

import { BriefCreatorTypeEnum } from "@nlc/shared-types";

import type { CreateVideoRequestFormData } from "../components/useCreateVideoRequestForm";

import {
  mapAttachmentsByCategory,
  useDuplicateRequest,
} from "../../shared/useDuplicateRequest";

function mapDuplicateResponseToFormData(
  data: DuplicateRequestResponse,
): DefaultValues<CreateVideoRequestFormData> {
  const briefCreatorType = data.briefText
    ? BriefCreatorTypeEnum.DETAILED
    : BriefCreatorTypeEnum.SINGLE;

  return {
    assets: mapAttachmentsByCategory(data.attachments, "asset"),
    brand: data.brandId || undefined,
    briefCreatorDetailed: {
      additionalGuidelines:
        data.magicalBriefCreator?.additionalGuidelines || "",
      brandGuidelines: data.magicalBriefCreator?.brandGuidelines || "",
      creativeGoal: data.magicalBriefCreator?.creativeGoals || "",
      finalBrief: data.briefText || "",
      finalBriefHTML: data.briefText || "",
      scope: data.magicalBriefCreator?.scope || "",
      script: data.magicalBriefCreator?.script || "",
    },
    briefCreatorSingle: {
      requestDescription: data.description || "",
      requestDescriptionHTML: data.description || "",
      textsForDesign: data.textForDesign || "",
      textsForDesignHTML: data.textForDesign || "",
    },
    briefCreatorType,
    collaboratorIds: data.collaboratorIds || [],
    creativeDirection: data.creativeDirection || undefined,
    designComplexity: data.complexityId || undefined,
    fileTypes: data.preferredFileType || "",
    inspirations: mapAttachmentsByCategory(data.attachments, "example"),
    lengthOrPlatform: data.lengthOrPlatform || "",
    musicGenre: data.musicGenre || "",
    preferredDesignerIds: data.preferredDesignerIds || [],
    requestName: data.name || "",
    sizes: data.sizesNeeded || "",
    style: data.styleOfVideo || "",
    videoType: data.designTypeId ?? undefined,
  };
}

interface UseDuplicateVideoRequestProps {
  reset: UseFormReset<CreateVideoRequestFormData>;
}

export function useDuplicateVideoRequest({
  reset,
}: UseDuplicateVideoRequestProps) {
  return useDuplicateRequest<CreateVideoRequestFormData>({
    mapDuplicateResponseToFormData,
    reset,
  });
}
